import React from 'react';

export const About = () => {

    return (
        <>
        <div id="about" className = "about-box">
            <div className="max-w-7xl px-6 mx-auto font-raleway content-center">
                <h1 className="text-center text-5xl md:text-6xl tracking-wider">About</h1>
                <div className="container">
                    <div className="c1" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600">
                        <img src="img/sujal.jpg" alt="Sujal"/>
                    </div>
                    <div className="c2 font-semibold">
                        <h2 className="tracking-wider" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600">
                            Sujal Modanwal
                        </h2>
                        <div data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600">
                            <p> 
                               Hi, I’m Sujal Modanwal, a Software Engineer at Microsoft with 2+ years of experience in full-stack development, 
                               delivering scalable, reliable, and production-grade systems used in real-world environments.
                            </p>
                            <p>
                             I design and build AI-driven solutions using modern web stacks, consistently staying aligned with the latest 
                             advancements in AI technologies. I bring a strong foundation in Data Structures, Algorithms, and Competitive Programming
                             (2000+ problems solved, Expert on Codeforces, 5★ on CodeChef), with a proven focus on clean architecture, performance 
                             optimization, and high-impact engineering. 
                            </p>
                        </div>
                    </div>
                </div>
                <div className='flex justify-around mt-10'><div className='vertical-line'></div></div>
            </div>
        </div>
        </>
    )
};